import Zones from "@/components/Zones/Zones";

const VentilationZonesPage = () => {
  return <Zones type="ventilation" />;
};

export default VentilationZonesPage;
